﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    lanebelop: undefined,
    rente: undefined,
    nedbetalingstidAar: undefined,
    nedbetalingstidMaaneder: undefined,
    visHeleKalkulator: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                
                return {
                    ...state,
                    ...action.payload,
                };
            }
            default:
                return state;
        }
    }
}
